/**
 * Companies hook
 * Manages companies list
 */

import { useEffect, useState } from 'react';
import type { Company } from '../../../shared/types';
import { getCompanies } from '../services/company.service';

export const useCompanies = () => {
  const [companies, setCompanies] = useState<Company[]>([]);
  const [loading, setLoading] = useState(true);

  const loadCompanies = async () => {
    try {
      setLoading(true);
      const companiesData = await getCompanies();
      setCompanies(companiesData);
    } catch (error) {
      console.error('Error loading companies:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCompanies();
  }, []);

  return {
    companies,
    loading,
    refreshCompanies: loadCompanies,
  };
};
